import { DropdownOptionsService } from '../../../../../../core/services/dropdown-options.service';
import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';

@Component({
  selector: 'laas-urgent-remark',
  templateUrl: './urgent-remark.component.html',
  styleUrls: ['./urgent-remark.component.scss']
})
export class UrgentRemarkComponent extends SessionBaseComponent implements OnInit {

  @Input() booking: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() urgentRemarkSaved: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;
  readonly preferenceKey: string;
  isVisible: boolean;
  columns: any[];
  selectedCols: any[];
  DOStatusOptions: any[];
  priorityOptions: any[];
  tmpDetails: any[];
  timezone: string;

  constructor(
    injector: Injector,
    private dropdownOptionService: DropdownOptionsService,
    private bookingService: BookingService) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.UrgentRemark;
    this.timezone = this.laasSetting.facilityTimeZone;
    this.isVisible = false;
    this.booking = null;
    this.tmpDetails = [];
    this.columns = [
      { field: 'priority', header: 'DO 急單' },
      { field: 'urgentFlag', header: '運輸急單' },
      { field: 'doNo', header: this.translateService.instant('DeliveryOrder.DoNo') },
      { field: 'invoiceNo', header: 'DO_INVOICE No.' },
      { field: 'consigneeKey', header: '客戶代碼' },
      { field: 'consigneeCompany', header: '客戶名稱' },
      { field: 'shipNotes', header: '備註' },
      { field: 'rushCar', header: '急車' },
      { field: 'cartonCnt', header: '箱數' },
      { field: 'totalGrossWeight', header: '毛重' },
      { field: 'totalNetWeight', header: '淨重' },
      { field: 'volumeWeight', header: '材積' },
      { field: 'doStatus', header: 'DO處理狀態' },
      { field: 'orgName', header: '下單公司' },
      { field: 'shipCorpName', header: '出貨公司' },
      { field: 'letterHeadOrgName', header: 'Letter Head公司' },
      { field: 'csr', header: 'CSR' },
      { field: 'dept', header: '部門' },
      { field: 'bookingCount', header: 'Booking次數' },
      { field: 'cancelDescr', header: '取消原因(多次派車原因)' },
      { field: 'loadingDate', header: '上車時間', dataType: 'date' },
      { field: 'loadingWho', header: '上車人員工號' },
      { field: 'leaveWhsDate', header: '出倉時間', dataType: 'date' },
      { field: 'leaveWhsWho', header: '出倉人員工號' },
      { field: 'eta', header: '到貨時間', dataType: 'date' },
      { field: 'arriveWho', header: '到貨人員工號' },
      { field: 'tmsUrl', header: 'TMS_URL' },
      { field: 'eArrivalDate', header: '預估到貨時間', dataType: 'date' },
      { field: 'createUser', header: '建立人員' },
      { field: 'createDt', header: '建立時間', dataType: 'date' },
      { field: 'updateUser', header: '更新人員' },
      { field: 'updateDt', header: '更新時間', dataType: 'date' }
    ];
    this.selectedCols = this.columns;
    this.DOStatusOptions = [];
    this.priorityOptions = [];
    this.visibleChange = new EventEmitter<any>();
    this.urgentRemarkSaved = new EventEmitter<any>();
  }

  @Input() get visible(): any {
    return this.isVisible;
  }
  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.tmpDetails = isNullOrEmpty(this.booking?.bookingDetails) ? [] : deepCopy(this.booking.bookingDetails);
    this.dropdownOptionService.getDOStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.DOStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionService.getPriorityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.priorityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  confirmBtnClick(event: any): void {
    this.bookingService.updateBookingDetails(this.tmpDetails)
      .subscribe({
        next: result => {
          this.dialog.close(event);
          this.urgentRemarkSaved.emit({ originalEvent: event });
        }
      });
  }

  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split(',').filter(x => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }
}
